import styled from "styled-components"

import theme from "../../../theme/"
import Icon from "../icon"
import { Link } from "gatsby"

const NAVIGATION_HEIGHT = "70px"

export const BurgerMenu = styled(Icon)`
  display: flex;
  padding: 0 20px;
  cursor: pointer;
  color: ${theme.brand.default};
  
  @media (min-width: 1024px) {
    display: none;
  }
`

export const NavLink = styled(Link)`
  display: inline-flex;
  color: inherit;
  margin: 1rem 0;
  width: 100%;
  height: 100%;
  align-items: center;
  padding: 1rem;
  text-decoration: none;
  justify-content: center;
  
  &.active{
    color: ${theme.brand.default};
  }
    
  @media (min-width: 1024px) {
    padding: 1rem;
    font-size: 0.9rem;
  }
`


export const NavItem = styled.li`
  display: inline-flex;
  list-style: none;
  align-items: center;
  font-weight: 500;
  width: 100%;
  justify-content: center;
 
  @media (min-width: 1024px) {
    width: auto;
    margin: 0 20px;
  }
     
`

export const NavBar = styled.ul`
  align-items: center;
  flex-direction: column;
  padding: 0;
  margin: 0;
  position: absolute;
  top: calc(${NAVIGATION_HEIGHT} + 4px);
  z-index: 1;
  width: 100%;
  background: ${theme.bg.default};
  display: ${props => props.open ? "inline-flex" : "none"};

  @media (min-width: 1024px) {
    display: inline-flex;
    position: relative;
    height: 100%;
    flex-direction: row;
    flex: 1 80%;
    top: 0;
  }
`
